export const cssBundleHref = "/build/css-bundle-LWE3XD5M.css";